// src/pages/orders-management/components/tabs/VendorTab.jsx

import Button from "../../../../components/ui/Button";
import Icon from "../../../../components/AppIcon";

const VendorTab = ({ order, vendors = [], vendorsLoading = false, onOpenModal }) => {
  const currentVendor = order?.vendor || null;
  const isHomeSample = !!order?.isHomeSample;

  console.log("order",order)
  console.log("isHomeSample",isHomeSample)

  const isHomeSampleEligibleVendor = (v) => {
    const type = String(v?.type || "").toUpperCase();
    const flag =
      v?.isHomeSample === true ||
      v?.homeSample === true ||
      v?.supportsHomeSample === true ||
      v?.canCollectHomeSample === true;

    // ✅ treat COLLECTION vendors as home-sample eligible
    if (type === "COLLECTION") return true;
    return !!flag;
  };

  const filteredVendors = vendors.filter(isHomeSampleEligibleVendor);

  const openAssignModal = () => {
    onOpenModal?.({
      vendors: filteredVendors,
      mode: "HOME_SAMPLE",
    });
  };

  const formatVendorType = (type) => {
    switch (String(type || "").toUpperCase()) {
      case "LAB":
        return "Laboratory";
      case "COLLECTION":
        return "Collection Center";
      case "DIAGNOSTIC":
        return "Diagnostic Center";
      default:
        return "Vendor";
    }
  };

  return (
    <div className="space-y-4">
      {/* ✅ If NOT home sample → show only "Not available" */}
      {!isHomeSample ? (
        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="flex items-center gap-2">
            <Icon name="Info" size={16} className="text-gray-500" />
            <p className="text-sm text-gray-700 font-medium">
              Not available for center booking
            </p>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            Vendor assignment is allowed only for Home Sample Collection orders.
          </p>
        </div>
      ) : (
        <>
          {/* ✅ Home sample vendor count */}
          <p className="text-xs text-gray-500 mt-0.5">
           
            <span className="ml-2 text-blue-600 font-medium">• Home Sample Only</span>
          </p>

          <div className="bg-white border border-gray-200 rounded-lg">
            <div className="flex items-center justify-between px-3 py-2.5 border-b border-gray-200">
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Vendor Assignment</h3>
                <p className="text-xs text-gray-500 mt-0.5">
                  {currentVendor ? "Assigned to vendor" : "Pending assignment"}
                  <span className="ml-2">• Home sample collection</span>
                </p>
              </div>

              {/* ✅ ONLY home-sample button */}
              <Button
                onClick={openAssignModal}
               
                className={`text-xs px-3 py-1.5 h-8 ${
                  vendorsLoading 
                    ? "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
                    : currentVendor
                    ? "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
                    : "bg-blue-600 hover:bg-blue-700 text-white"
                }`}
                title={
                  filteredVendors.length === 0
                    ? "No Home Sample Collection vendors available"
                    : undefined
                }
              >
                <Icon
                  name={currentVendor ? "RefreshCw" : "Truck"}
                  size={12}
                  className="mr-1.5"
                />
                {currentVendor ? "Reassign Home Sample" : "Assign Home Sample"}
              </Button>
            </div>

            <div className="p-3">
              {currentVendor ? (
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-blue-50 rounded-lg border border-blue-100">
                      <Icon name="Building" size={16} className="text-blue-600" />
                    </div>

                    <div className="flex-1">
                      <div className="flex items-start justify-between">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">{currentVendor.name}</p>

                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-xs px-2 py-0.5 bg-blue-100 text-blue-800 rounded">
                              {formatVendorType(currentVendor.type)}
                            </span>

                            <span className="text-xs px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded">
                              Home Sample
                            </span>

                            {currentVendor.rating && (
                              <div className="flex items-center gap-1">
                                <Icon
                                  name="Star"
                                  size={10}
                                  className="text-amber-400 fill-amber-400"
                                />
                                <span className="text-xs text-gray-600">
                                  {currentVendor.rating}/5
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded font-medium">
                          Assigned
                        </span>
                      </div>

                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
                        <div className="text-center">
                          <p className="text-xs text-gray-500">Contact</p>
                          <p className="text-sm font-medium text-gray-900">
                            {currentVendor.contactPerson || "—"}
                          </p>
                        </div>

                        <div className="text-center">
                          <p className="text-xs text-gray-500">Phone</p>
                          <p className="text-sm font-medium text-gray-900">
                            {currentVendor.number || "—"}
                          </p>
                        </div>

                        <div className="text-center">
                          <p className="text-xs text-gray-500">Email</p>
                          <p className="text-sm font-medium text-gray-900 truncate">
                            {currentVendor.email || "—"}
                          </p>
                        </div>

                        <div className="text-center">
                          <p className="text-xs text-gray-500">Location</p>
                          <p className="text-sm font-medium text-gray-900">
                            {currentVendor.city} - {currentVendor.pincode}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-lg border border-gray-200 p-2.5">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                      <div>
                        <p className="text-xs text-gray-500">Assigned On</p>
                        <p className="text-sm font-medium text-gray-900">
                          {order?.vendorAssignedAt
                            ? new Date(order.vendorAssignedAt).toLocaleDateString("en-IN", {
                                day: "numeric",
                                month: "short",
                              })
                            : "—"}
                        </p>
                      </div>

                      <div>
                        <p className="text-xs text-gray-500">Status</p>
                        <span
                          className={`text-xs px-2 py-0.5 rounded font-medium ${
                            order?.vendorStatus === "ACCEPTED"
                              ? "bg-green-100 text-green-700"
                              : order?.vendorStatus === "PENDING"
                              ? "bg-amber-100 text-amber-700"
                              : "bg-gray-100 text-gray-700"
                          }`}
                        >
                          {order?.vendorStatus || "Pending"}
                        </span>
                      </div>

                      <div>
                        <p className="text-xs text-gray-500">Turnaround</p>
                        <p className="text-sm font-medium text-gray-900">
                          {currentVendor.turnaroundTime || "24"} hrs
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-4">
                  <Icon name="Package" size={24} className="mx-auto mb-2 text-gray-300" />
                  <p className="text-sm font-medium text-gray-900">No vendor assigned</p>
                  <p className="text-xs text-gray-500 mt-0.5 mb-3">
                    Assign a home sample collection vendor for this order
                  </p>

                  <Button
                    onClick={openAssignModal}
                   
                    className={`text-xs px-3 py-1.5 ${
                      vendorsLoading 
                        ? "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700 text-white"
                    }`}
                  >
                    <Icon name="Truck" size={12} className="mr-1.5" />
                    Assign Home Sample Now
                  </Button>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default VendorTab;
